  <header>
     <img class="img-fluid" src="../../../assets/img/velmaral-banner.jpg" alt="logo">
  </header>
<section class="bg-white login">
  <div class="container py-4 mt-2">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div class="card shadow-lg p-lg-1 p-5 bg-light">
          <div class="text-center">
            <!-- <a href="https://booking.cktechsoln.in/">
              <img class="img-fluid" src="../../../assets/img/murugan-logo.jpg" alt="logo"
                style="height: 100px; width:130p;">
            </a> -->
          </div>
          <div class="card-body">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
              <div class="row mt-2">
                <div class="col-12 mt-3">
                  <div class="form-floating mb-3">
                    <input type="text" class="form-control" placeholder="Username" formControlName="username">
                    <label class="text-gray">Username</label>
                    <div *ngIf="f.username.touched && f.username.invalid" class="text-danger">
                      Username required
                    </div>
                  </div>
                </div>

                <div class="col-12 mt-3 position-relative">
                  <div class="form-floating mb-3">
                    <input [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="Password"
                      formControlName="password">
                    <label class="text-gray">Password</label>
                    <div *ngIf="f.password.touched && f.password.invalid" class="text-danger">
                      Password required
                    </div>

                    <!-- Eye icon -->
                    <span class="position-absolute top-50 end-0 translate-middle-y me-3" style="cursor: pointer;"
                      (click)="togglePassword()">
                      <i [ngClass]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                    </span>

                  </div>
                </div>


                <div class="col-lg-12 p-0 m-0 text-center">
                  <button type="submit" class="btn btn-success mt-3 mb-3">Login</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-cktech-footer></app-cktech-footer>
<ngx-spinner>
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>